var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02935 0.836533L3.95619 0.763674H3.85294L2 0.763674L1.39573 0.763674L1.82337 1.1906L9.82337 9.17723L10 9.35356L10.1766 9.17723L18.1766 1.1906L18.6043 0.763674H18L16.5 0.763674H16.4008L16.3286 0.831682L10.0049 6.78743L4.02935 0.836533Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBoldIcon);
export default __webpack_public_path__ + "static/media/arrow-down-bold-icon.a57949d9f5ffcd9f5190196e0c8206d0.svg";
export { ForwardRef as ReactComponent };